"use client";

import { useEffect, useRef } from "react";
import { Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  author: "María G.",
  position: "Clienta",
  quote: "Una experiencia gastronómica única, la decoración y el sabor son inigualables.",
  rating: 5
}, {
  id: 2,
  author: "Carlos P.",
  position: "Cliente",
  quote: "El ambiente es perfecto para una noche especial, y el mezcal es excepcional.",
  rating: 5
}, {
  id: 3,
  author: "Ana M.",
  position: "Visitante",
  quote: "Cada plato refleja la tradición mexicana con un toque moderno, simplemente espectacular.",
  rating: 5
}, {
  id: 4,
  author: "Roberto L.",
  position: "Cliente",
  quote: "Servicio impecable y una vista increíble. Definitivamente volveremos.",
  rating: 5
}];
export default function Testimonios() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const carouselRef = useRef<CarouselApi | null>(null);
  const autoplayIntervalRef = useRef<NodeJS.Timeout | null>(null);
  const isHoveredRef = useRef(false);
  const startAutoplay = () => {
    if (autoplayIntervalRef.current) {
      clearInterval(autoplayIntervalRef.current);
    }
    autoplayIntervalRef.current = setInterval(() => {
      if (!isHoveredRef.current && carouselRef.current) {
        carouselRef.current.scrollNext();
      }
    }, 4000);
  };
  useEffect(() => {
    startAutoplay();
    return () => {
      if (autoplayIntervalRef.current) {
        clearInterval(autoplayIntervalRef.current);
      }
    };
  }, []);
  const handleMouseEnter = () => {
    isHoveredRef.current = true;
  };
  const handleMouseLeave = () => {
    isHoveredRef.current = false;
  };
  return <section id="testimonios" ref={ref} className={`relative py-20 md:py-28 bg-gradient-to-br from-muted-light-background via-background to-muted-light-background overflow-hidden transition-opacity duration-[var(--duration-medium)] ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-4">
            Lo Que Dicen Nuestros Clientes
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto">
            Experiencias auténticas de quienes han disfrutado nuestra cocina
          </p>
        </div>

        <div className="relative px-12 md:px-16" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <Carousel opts={{
          align: "start",
          loop: true
        }} setApi={api => {
          carouselRef.current = api;
        }} className="w-full">
            <CarouselContent className="-ml-4 md:-ml-6">
              {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/3">
                  <Card className="h-full bg-background border border-border shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] p-8">
                    <CardContent className="flex flex-col gap-6 p-0">
                      <div className="flex gap-1">
                        {Array.from({
                      length: testimonial.rating
                    }).map((_, index) => <Star key={index} className="size-5 fill-accent text-accent" />)}
                      </div>

                      <blockquote className="text-foreground text-base md:text-lg leading-relaxed">
                        "{testimonial.quote}"
                      </blockquote>

                      <div className="mt-auto pt-4 border-t border-border">
                        <p className="font-semibold text-foreground text-lg">
                          {testimonial.author}
                        </p>
                        <p className="text-muted-foreground text-sm">
                          {testimonial.position}
                        </p>
                      </div>
                    </CardContent>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>

            <CarouselPrevious className="bg-background border-border hover:bg-muted hover:border-primary transition-all duration-[var(--duration-fast)]" />
            <CarouselNext className="bg-background border-border hover:bg-muted hover:border-primary transition-all duration-[var(--duration-fast)]" />
          </Carousel>
        </div>
      </div>
    </section>;
}